module.exports = __webpack_public_path__ + "assets/media/sfdc-logo.d670b558.webp";